import DateDisplay from "components/datetime/DateDisplay";
import { useTranslation } from "react-i18next";
import DeviceParamsModal from "./DeviceParamsModal";
import { useState } from "react";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareArrowUpRight } from "@fortawesome/free-solid-svg-icons";
const TabOthers = ({ item }) => {
    const { t: _Td } = useTranslation("datestimes");
    const { t: _TC } = useCustomTranslation(translations);
    const [isOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState(null);

    const openDeviceParamsModal = (event, type) => {
        event.preventDefault();
        setModalType(type);
        setIsOpen(true);
    };

    return (
        <>
            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="installed_at" className="form-label">
                        {_Td("labels.installed_at")}
                    </label>
                </div>

                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="installed_at"
                        name="installed_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="last_comm_at" className="form-label">
                        {_Td("labels.last_com_at")}
                    </label>
                </div>
                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="last_comm_at"
                        name="last_comm_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="manufacturer_at" className="form-label">
                        {_Td("labels.manufacturer_at")}
                    </label>
                </div>

                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="manufacturer_at"
                        name="manufacturer_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="updated_at" className="form-label">
                        {_Td("labels.updated_at")}
                    </label>
                </div>

                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="updated_at"
                        name="updated_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="created_at" className="form-label">
                        {_Td("labels.created_at")}
                    </label>
                </div>
                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="created_at"
                        name="created_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-4 text-md-end mt-2">
                    <label htmlFor="end_at" className="form-label">
                        {_Td("labels.end_at")}
                    </label>
                </div>
                <div className="col-md-4">
                    <input
                        type="datetime-local"
                        className="form-control mb-2"
                        id="end_at"
                        name="end_at"
                        defaultValue={<DateDisplay date={item.created_at} title={true} />}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
            </div>
            <div className="row ps-3 pe-3">
                <div className="col-12 mt-2">
                    <label htmlFor="notes" className="form-label">
                        {_Td("common.note")}
                    </label>
                </div>
                <div className="col-12">
                    <textarea name="notes" id="notes" className="form-control" rows={4} defaultValue={item.notes} />
                </div>
            </div>

            <div className="row w-full justify-content-center align-items-center">
                <div className="mt-4 p-4 w-full">
                    <Table bordered responsive className="text-center">
                        <thead>
                            <tr>
                                <th>{_TC("deviceddparams")}</th>
                                <th>
                                    <FontAwesomeIcon
                                        icon={faSquareArrowUpRight}
                                        size="2xl"
                                        onClick={(e) => openDeviceParamsModal(e, "dd")}
                                    />
                                </th>
                            </tr>
                            <tr>
                                <th>{_TC("devicenfc_report")}</th>
                                <th>
                                    <FontAwesomeIcon
                                        icon={faSquareArrowUpRight}
                                        size="2xl"
                                        onClick={(e) => openDeviceParamsModal(e, "nfc")}
                                    />
                                </th>
                            </tr>
                        </thead>
                    </Table>
                </div>
            </div>

            <DeviceParamsModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                device={item}
                type={modalType}
            />
        </>
    );
};
export default TabOthers;
